export default {"src":"/_next/static/media/stag_naik.e834fc10.svg","height":268,"width":267,"blurWidth":0,"blurHeight":0};